<app-header></app-header>
<div class="body-container">
    <div class="row">
        <div class="col-12 models-list">
            <div class="row decision-model-title-container">
                <h1 class="decision-title font-mont-regular">Multi Risk</h1>
                <button class="btn btn-secondary font-mont-regular float-right" type="submit"
                    (click)="onCreateNewModelSubmit()" id="createNewDecisionModelOpenDlgBtn">
                    <div class="tooltip-two">
                        <div class="plus-area">
                            <i class="fas fa-plus"></i>
                        </div>
                        <span class="tooltip-two-text">
                            Click here to add a new model.
                        </span>
                    </div>
                </button>
            </div>
            <div class="form-row">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="text-left font-mont-semi-bold">
                                <div class="font-mont-semi-bold margin-r-20 v-center" (click)="onSortClick('name')">
                                    Name
                                </div>
                                <i class="fas fa-caret-up caret-up-icon v-center"
                                    *ngIf="!invertedSort && sortField == 'name'"></i>
                                <i class="fas fa-caret-down caret-down-icon v-center"
                                    *ngIf="invertedSort && sortField == 'name'"></i>
                            </th>
                            <th scope="col" class="text-center font-mont-semi-bold">
                                <div class="font-mont-semi-bold margin-r-20 v-center" (click)="onSortClick('active')">
                                    Status
                                </div>
                                <i class="fas fa-filter filter-icon" [ngClass]="{'v-center': sortField != 'active'}"
                                    (click)="toggleStatusFilter()"></i>
                                <i class="fas fa-caret-up caret-up-icon"
                                    *ngIf="!invertedSort && sortField == 'active'"></i>
                                <i class="fas fa-caret-down caret-down-icon"
                                    *ngIf="invertedSort && sortField == 'active'"></i>
                                <div class="apps-menu" [ngClass]="{'open': statusFilterOpen}"
                                    (click)="toggleStatusFilter()">
                                    <div class="backdrop"></div>
                                    <div class="apps-menu-container">
                                        <div (click)="onStatusCheckClick('active', '');">
                                            <i *ngIf="filterValue == ''" class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != ''" class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> All </span>
                                            <div class="clear"></div>
                                        </div>
                                        <div (click)="onStatusCheckClick('active', 'true');">
                                            <i *ngIf="filterValue == 'true'" class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != 'true'" class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> Active </span>
                                            <div class="clear"></div>
                                        </div>
                                        <div (click)="onStatusCheckClick('active', 'false');">
                                            <i *ngIf="filterValue == 'false'" class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != 'false'" class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> Inactive </span>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="text-center font-mont-semi-bold">
                                <div class="font-mont-semi-bold margin-r-20 v-center"
                                    (click)="onSortClick('outcomeName')">
                                    Outcome</div>
                                <i class="fas fa-filter filter-icon"
                                    [ngClass]="{'v-center': sortField != 'outcomeName'}"
                                    (click)="toggleOutcomeFilter()"></i>
                                <i class="fas fa-caret-up caret-up-icon"
                                    *ngIf="!invertedSort && sortField == 'outcomeName'"></i>
                                <i class="fas fa-caret-down caret-down-icon"
                                    *ngIf="invertedSort && sortField == 'outcomeName'"></i>
                                <div class="apps-menu" [ngClass]="{'open': outcomeFilterOpen}"
                                    (click)="toggleOutcomeFilter()">
                                    <div class="backdrop"></div>
                                    <div class="apps-menu-container">
                                        <div (click)="onStatusCheckClick('outcomeName', '');">
                                            <i *ngIf="filterValue == ''" class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != ''" class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> All </span>
                                            <div class="clear"></div>
                                        </div>
                                        <div *ngFor="let outcome of outcomes"
                                            (click)="onStatusCheckClick('outcomeName', outcome.description);">
                                            <i *ngIf="filterValue == outcome.description"
                                                class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != outcome.description" class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> {{outcome.description}} </span>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="text-center position-relative">
                                <div class="font-mont-semi-bold margin-r-20" (click)="onSortClick('datarobotName')">
                                    Datarobot
                                </div>
                                <div class="font-mont-semi-bold margin-r-20" (click)="onSortClick('datarobotName')">
                                    Model
                                </div>
                                <i class="fas fa-filter filter-icon"
                                    [ngClass]="{'v-center': sortField != 'datarobotName'}"
                                    (click)="toggleDataRobotModelFilter()"></i>
                                <i class="fas fa-caret-up caret-up-icon"
                                    *ngIf="!invertedSort && sortField == 'datarobotName'"></i>
                                <i class="fas fa-caret-down caret-down-icon"
                                    *ngIf="invertedSort && sortField == 'datarobotName'"></i>
                                <div class="apps-menu" [ngClass]="{'open': dataRobotModelFilterOpen}"
                                    (click)="toggleDataRobotModelFilter()">
                                    <div class="backdrop"></div>
                                    <div class="apps-menu-container">
                                        <div *ngFor="let dataRobotModel of dataRobotModels"
                                            (click)="onStatusCheckClick('datarobotName', dataRobotModel.description);">
                                            <i *ngIf="filterValue == dataRobotModel.description"
                                                class="fas fa-check-square"></i>
                                            <i *ngIf="filterValue != dataRobotModel.description"
                                                class="fas fa-square"></i>
                                            <span class="font-mont-semi-bold"> {{dataRobotModel.description ?
                                                dataRobotModel.description : 'All'}} </span>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="text-center font-mont-semi-bold">
                                <div class="font-mont-semi-bold margin-r-20 v-center" (click)="onSortClick('priority')">
                                    Priority
                                </div>
                                <i class="fas fa-caret-up caret-up-icon v-center"
                                    *ngIf="!invertedSort && sortField == 'priority'"></i>
                                <i class="fas fa-caret-down caret-down-icon v-center"
                                    *ngIf="invertedSort && sortField == 'priority'"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container
                            *ngFor="let model of models | filter:filter:filterValue | sort:sortField:invertedSort; let i = index">
                            <tr (click)="toggleSelectedRow(i, model.id);" class="row-data cursor-pointer"
                                [ngClass]="{'selected': selectedRow == i}" [attr.id]="'itemNumber_' + i">
                                <td scope="row">{{model.name}}</td>
                                <td class="text-center">{{model.active ? 'Active' : 'Inactive'}}</td>
                                <td class="text-center">{{model.outcomeName}}</td>
                                <td class="text-center">{{model.datarobotName}}</td>
                                <td class="text-center">{{model.priority}}</td>
                            </tr>
                            <tr class="no-highlight summary" [ngClass]="{'selected': selectedRow == i}">
                                <td colspan="5">
                                    <div *ngIf="tempSelectedRow == i">
                                        <app-multi-risk-item [outcomes]="outcomes" [dataRobotModels]="dataRobotModels"
                                            [attributes]="attributes" [operators]="operators" [modelId]="modelId"
                                            (itemLoaded)="onItemLoaded();" (getModelList)="getModelList($event);"
                                            (showErrorMessage)="showErrorMessage($event);">
                                        </app-multi-risk-item>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addNewModelModal" tabindex="-1" role="dialog" aria-labelledby="addNewModelModal"
    data-keyboard="false" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/assets/images/icons/close_b.svg" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <h5 class="modal-title w-100 text-left font-mont-bold" id="exampleModalLongTitle">
                    <img src="/assets/images/icons/add_blue.svg" />
                    ADD NEW MODEL
                </h5>
                <form [formGroup]="newModelForm" (ngSubmit)="onCreateSubmit();">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="newModelName"
                                        [ngClass]="{ 'color-red': addNewModelSubmitted && newModelForm.controls.name.errors }">Name:
                                        *</label>
                                    <input type="text" formControlName="name" class="form-control" id="newModelName"
                                        placeholder="Name" name="name"
                                        [ngClass]="{ 'is-invalid': addNewModelSubmitted && newModelForm.controls.name.errors }">
                                    <div *ngIf="addNewModelSubmitted && newModelForm.controls.name.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="newModelForm.controls.name.errors.required">
                                            Name is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="newModelDescription"
                                        [ngClass]="{ 'color-red': addNewModelSubmitted && newModelForm.controls.description.errors }">Description:
                                        *</label>
                                    <textarea formControlName="description" class="form-control"
                                        id="newModelDescription" rows="4" placeholder="Description" name="description"
                                        [ngClass]="{ 'is-invalid': addNewModelSubmitted && newModelForm.controls.description.errors }"></textarea>
                                    <div *ngIf="addNewModelSubmitted && newModelForm.controls.description.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="newModelForm.controls.description.errors.required">
                                            Description is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button type="submit"
                                class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular float-right">
                                ADD MODEL
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-error-dialog [modalId]="modalId" [title]="messageTitle" [messageA]="messageMessageA" [messageB]="messageMessageB"
    [messageC]="messageMessageC" [messageBClass]="messageMessageBClass" [dialogClass]="dialogClass"></app-error-dialog>